<template>
  <div class="body d-flex mb-3">
    <div class="container-xxl">
      <div class="d-flex mb-3 justify-content-end justify-content-center-mobile">
        <button type="button" class="ms-0 ms-sm-3 btn btn-company" @click.prevent="createEvent">
          <i class="icofont-plus-circle me-2 fs-6"></i>Νέα Εκδήλωση
        </button>
      </div>
      <ul class="row px-0 nav nav-tabs rounded mt-sm-0 mb-3 mt-3 prtab-set" role="tablist">
        <li class="nav-item col-3 px-1 px-sm-3">
          <a
            :class="{
              'nav-link text-center active':
                filters.event_status_id == '0' ||
                filters.event_status_id == undefined,
              'nav-link text-center':
                filters.event_status_id != '0' &&
                filters.event_status_id != undefined,
            }"
            @click.prevent="() => updateFilters({ ...filters, event_status_id: '0', page: 1 })"
            href="#"
            role="tab"
            >Όλες</a
          >
        </li>
        <li class="nav-item col-3 px-1 px-sm-3">
          <a
            :class="{
              'nav-link text-center active': filters.event_status_id == '1',
              'nav-link text-center': filters.event_status_id != '1',
            }"
            @click.prevent="() => updateFilters({ ...filters, event_status_id: '1', page: 1 })"
            href="#"
            role="tab"
            >Πρόχειρες</a
          >
        </li>
        <li class="nav-item col-3 px-1 px-sm-3">
          <a
            :class="{
              'nav-link text-center active': filters.event_status_id == '2',
              'nav-link text-center': filters.event_status_id != '2',
            }"
            @click.prevent="() => updateFilters({ ...filters, event_status_id: '2', page: 1 })"
            href="#"
            role="tab"
            >
            Αναρτημένες
          </a>
        </li>
        <li class="nav-item col-3 px-1 px-sm-3">
          <a
            :class="{
              'nav-link text-center active': filters.event_status_id == '3',
              'nav-link text-center': filters.event_status_id != '3',
            }"
            @click.prevent="() => updateFilters({ ...filters, event_status_id: '3', page: 1 })"
            href="#"
            role="tab"
            >ΛΗΓΜΕΝΕΣ</a
          >
        </li>
      </ul>

      <div class="row px-1 mb-3">
        <div class="col-12 col-sm-6 col-lg-4 mb-4" v-for="(event, index) in data || []" :key="event.id">
          <div class="card event-card">
            <div class="card-body pb-4 d-flex flex-column justify-content-between gap-2">
              <div class="eventInnerDesc d-flex flex-column rounded p-3">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <div>
                    <span class="card-date bg-white px-3 py-2 fw-bold">
                      {{ event.earliest_date }} - {{ event.latest_date }}
                    </span>
                  </div>
                  <!-- <div>
                    <button class="btn btn-modal" @click="duplicateEvent(event)">
                      <i class="icofont-ui-copy fs-5"></i>
                    </button>
                  </div> -->
                </div>
                <div>
                  <div class="mb-1">
                    <span class="text-uppercase fw-bold">
                      {{event.venue.title}}
                    </span>
                  </div>

                  <div>
                    <h4 class="fs-4 fw-bold">{{ event.title }}</h4>
                  </div>

                  <div class="d-flex">
                    <span class="cat-text bg-white">
                      {{event.category.title}}
                    </span>
                  </div>
    
                  <div v-if="event.start && event.end" class="mt-2">
                    <small>
                      <b>Ώρα:</b> {{ event.start }} - {{ event.end }}
                    </small>
                  </div>

                  <div v-if="event.zones && event.zones.length" class="mt-2">
                    <p class="d-block zones-title"><b>Ζώνες εισιτηρίων:</b></p>
                    <ul class="list-ordered mb-0">
                      <li v-for="(zone, index) in event.zones" :key="index">
                        {{ zone.title }} ({{ zone.price }} €)
                        <span v-if="zone.remaining === 0" class="fw-bold text-danger ms-1">     
                          (Sold Out)
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div v-if="event.special_category_discounts && event.special_category_discounts.length" class="mt-2">
                    <small class="d-block special-category-title">
                      <b>Ειδικές κατηγορίες εκπτώσεων:</b>
                    </small>
                    <ul class="list-ordered mb-0">
                      <li v-for="(category, index) in event.special_category_discounts" :key="index">
                        {{ category.title }} (-{{ category.discount }} %)
                      </li>
                    </ul>
                  </div>
                </div>
               
                  <div class="event-actions">
                     <router-link :to="`/event/${event.id}`">
                      <button class="btn shadow-sm bg-white" v-if="isEventDraft(event)">
                        <i class="icofont icofont-eye fs-6 text-primary"></i>
                      </button>
                    </router-link>

                    <button @click="showEventModal(event)" class="btn shadow-sm bg-white ms-2">
                      <i class="icofont icofont-edit fs-6 text-primary"></i>
                    </button>

                    <button class="btn shadow-sm bg-white ms-2" @click="confirmAction(event)">
                      <i class="icofont icofont-trash fs-6 text-danger"></i>
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3" v-if="!data || !data.length">
          <p>Δεν βρέθηκαν αποτελέσματα.</p>
        </div>
      </div>
    </div>
    <div class="modal fade" id="confirmationModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold" id="confirmationModalLabel">
              Επιβεβαίωση ενέργειας
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ confirmationMessage }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Άκυρο
            </button>
            <button type="button" class="btn btn-primary" @click="submitDelete">
              Διαγραφή
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="create-event-form" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold" id="createEventlLabel">
              Στοιχεία Εκδήλωσης
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="eventTitle" class="form-label" aria-label="Title" aria-placeholder="Title">
                Τίτλος
              </label>
              <input type="text" class="form-control" id="eventTitle" placeholder="Τίτλος" name="title"v-model="eventData.title"/>
            </div>

            <div class="row">
              <div class="mb-3 col-md-4">
                <label class="form-label">Κατηγορία</label>
                <select class="form-select" v-model="eventData.event_category_id" @aange="onCategoryChange">
                  <option value="" disabled selected>Επιλέξτε Κατηγορία</option>
                  <option v-for="category in categories" :key="category.id" :value="category.id">
                    {{ category.title }}
                  </option>
                </select>
              </div>
              <div class="mb-3 col-md-4">
                <label class="form-label">Status</label>
                <select class="form-select" v-model="eventData.event_status_id">
                  <option value="1">ΠΡΟΧΕΙΡΗ</option>
                  <option value="2">ΑΝΑΡΤΗΜΕΝΗ</option>
                </select>
              </div>
              <div class="mb-3 col-md-4">
                <label class="form-label">Χώρος Εκδήλωσης</label>
                <select class="form-select" v-model="eventData.venue_id">
                  <option value="" disabled selected>
                    Επιλέξτε Χώρο Εκδήλωσης
                  </option>
                  <option v-for="venue in venues" :key="venue.id" :value="venue.id">
                    {{ venue.title }}
                  </option>
                </select>
              </div>
            </div>

            <div class="mb-3">
              <label for="description" class="form-label" aria-label="Περιγραφή" aria-placeholder="Περιγραφή">
                Περιγραφή
              </label>
              <textarea class="form-control" id="description" placeholder="Περιγραφή" aria-label="Περιγραφή" name="description" v-model="eventData.description" rows="4"></textarea>
            </div>


            <div class="row">
              <div class="col-6 mb-3">         
                <ImageUpload
                  label="Top Banner"
                  :currentImage="eventData.top_banner_img_url || null"
                  @file-selected="selectedTopBannerFile = $event"
                  @remove-current-image="eventData.top_banner_img_url = null"
                />
              </div>
              <div class="col-6 mb-3">
                <ImageUpload
                  label="Zone Image"
                  :currentImage="eventData.zone_img_url || null"
                  @file-selected="selectedZoneFile = $event"
                  @remove-current-image="eventData.zone_img_url = null"
                />
              </div>
            </div>
            
            <div class="mb-3 px-1 px-sm-3">
              <div v-for="(zone, index) in eventData.zones" :key="index" class="border rounded p-sm-3 mb-2 position-relative row">
                <button type="button" class="btn-close position-absolute" aria-label="Close" @click="removeZone(index)"></button>

                <div class="mb-2 col-md-4">
                  <label class="form-label">Τίτλος</label>
                  <input type="text" class="form-control" v-model="zone.title" placeholder="Όνομα ζώνης" required/>
                </div>

                <div class="mb-2 col-md-4">
                  <label class="form-label">Τιμή (€)</label>
                  <input type="number" class="form-control" v-model="zone.price" step="0.01" required/>
                </div>

                <div class="mb-2 col-md-4">
                  <label class="form-label">Διαθέσιμα Εισιτήρια</label>
                  <input type="number" class="form-control" v-model="zone.count" min="0" required/>
                </div>
              </div>

              <button type="button" class="btn btn-sm ms-sm-3 me-3 add-zone-btn" @click="addZone">
                Προσθήκη Ζώνης <i class="icofont-plus"></i>
              </button>

              <div v-if="totalTickets > selectedVenueCapacity" class="text-danger small mt-1">
                Το σύνολο των διαθέσιμων εισιτηρίων ξεπερνά τη χωρητικότητα του χώρου ({{ selectedVenueCapacity }}).
              </div>
            </div>

            <div class="mb-3 px-1 px-sm-3">
              <div v-for="(event_dates, index) in eventData.event_dates" :key="index" class="border rounded p-sm-3 mb-2 position-relative row">
                <button type="button" class="btn-close position-absolute" aria-label="Close" @click="removeDate(index)"></button>

                <div class="mb-2 col-md-4">
                  <label class="form-label">Hμ/νια Εκδήλωσης</label>
                  <input type="date" class="form-control" v-model="event_dates.date" placeholder="Hμ/νια Εκδήλωσης" required/>
                </div>

                <div class="mb-2 col-md-4">
                  <label class="form-label">Ώρα Έναρξης </label>
                  <input type="time" class="form-control" v-model="event_dates.start_time" required/>
                </div>

                <div class="mb-2 col-md-4">
                  <label class="form-label">Ώρα Λήξης</label>
                  <input type="time" class="form-control" v-model="event_dates.end_time" required/>
                </div>
              </div>

              <button type="button" class="btn btn-sm ms-sm-3 me-3 add-date-btn" @click="addDate">
                Προσθήκη Ημερομηνίας <i class="icofont-plus"></i>
              </button>

              <div v-if="totalTickets > selectedVenueCapacity" class="text-danger small mt-1">
                Το σύνολο των διαθέσιμων εισιτηρίων ξεπερνά τη χωρητικότητα του χώρου ({{ selectedVenueCapacity }}).
              </div>
            </div>
            <div class="mb-3 px-1 px-sm-3">
              <div v-for="(special_category, index) in eventData.special_category_discounts" :key="index" class="border rounded p-sm-3 mb-2 position-relative row">
                <button type="button" class="btn-close position-absolute" aria-label="Close" @click="removeSpecialZone(index)"></button>
                <div class="mb-2 col-md-6">
                  <label class="form-label">Ειδική κατηγορία</label>
                  <input type="text" class="form-control" v-model="special_category.title" placeholder="Όνομα ειδικής κατηγορίας" required/>
                </div>

                <div class="mb-2 col-md-6">
                  <label class="form-label">Έκπτωση (%)</label>
                  <input type="number" class="form-control" v-model="special_category.discount" step="0.01" required/>
                </div>
              </div>

              <button type="button" class="btn btn-sm ms-sm-3 me-3" @click="addSpecialZone">Προσθήκη Ειδικής Κατηγορίας <i class="icofont-plus"></i></button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Κλείσιμο
            </button>
            <button type="button" class="btn btn-company" @click.prevent="submitForm">
              Αποθήκευση
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, onUnmounted} from "vue";
  import { useFetchData } from "@/composables/useFetchData";
  import {fetchAllAdmin, getEventCategories, createUpdateEvent, deleteEvent, getSpecialCategories} from "@/services/events";
  import { fetchVenues as fetchVenuesApi } from "@/services/venues";
  import { useRoute, useRouter } from "vue-router";
  import { useToast } from "vue-toastification";
  import "vue-toastification/dist/index.css";
  import { useHead } from "@vueuse/head";
  import ImageUpload from "@/components/ImageUpload.vue";
  import { filesUpload } from "@/services/events";


  const defaulteventData = {
    title: "",
    description: "",
    event_status_id: "",
    event_category_id: "",
    zones: [],
    event_dates: [],
    special_category_discounts: [],
    top_banner_img: null,
    zone_img_url: null,
    delete_top_banner_img: false,
  };

  
  const route = useRoute();
  const router = useRouter();

  const { data, filters, updateFilters, fetchData, sortBy } =
    useFetchData(
      fetchAllAdmin,
      { page: route.query.page || 1, active: route.query.active || 1 },
      { page: 1, active: 1 }
    );

  const eventToActOn = ref(null);
  const confirmationMessage = ref("");
  const eventData = ref(defaulteventData);
  const categories = ref([]);
  const special_categories = ref([]);
  const venues = ref([]);
  const selectedFile = ref(null);
  const selectedTopBannerFile = ref(null);
  const selectedZoneFile = ref(null);


  const toast = useToast();
  const addDate = () => eventData.value.event_dates.push({ date: "", start_time: 0, end_time: 0 });
  const removeDate = (index) => eventData.value.event_dates.splice(index, 1);
  const addZone = () => eventData.value.zones.push({ title: "", price: 0, count: 0 });
  const removeZone = (index) => eventData.value.zones.splice(index, 1);
  const addSpecialZone = () => eventData.value.special_category_discounts.push({ title: "", discount: 0 });
  const removeSpecialZone = (index) => eventData.value.special_category_discounts.splice(index, 1);

  const totalTickets = computed(() => eventData.value.zones.reduce((sum, zone) => sum + Number(zone.count || 0), 0));
  
  const selectedVenueCapacity = computed(() => {
    const venue = venues.value.find((v) => v.id === eventData.value.venue_id);
    return venue ? Number(venue.capacity) : 0;
  });

  const isEventDraft = (event) => Number(event.event_status_id) === 1;


  const confirmAction = (event) => {
    eventToActOn.value = event;
    confirmationMessage.value = `Είστε σίγουροι ότι θέλετε να διαγράψετε την εκδήλωση: ${event.title}?`;
    $("#confirmationModal").modal("show");
  };

  const submitDelete = async () => {
    const r = await deleteEvent(eventToActOn.value.id);
    if (r.data.success) {
      useToast().success(r.data.message);
      fetchData();
    } else {
      useToast().error(r.data.message);
    }
    $("#confirmationModal").modal("hide");
  };

  const fetchCategories = async () => {
    const response = await getEventCategories();
    if (response.data.success) {
      categories.value = response.data.data;
    } else {
      useToast().error("Failed to load categories.");
    }
  };

  const fetchSpecialCategories = async () => {
    const response = await getSpecialCategories();
    if (response.data.success) {
      special_categories.value = response.data.data;
    } else {
      useToast().error("Failed to load categories.");
    }
  };

  const fetchVenues = async () => {
    const response = await fetchVenuesApi();
    if (response.data.success) {
      venues.value = response.data.data;
    } else {
      useToast().error("Failed to load categories.");
    }
  };

  const onCategoryChange = () => { const selectedCategory = eventData.value.event_category_id; };

  const createEvent = async () => {
    await fetchCategories();
    await fetchSpecialCategories();
    await fetchVenues();
    eventData.value = { ...defaulteventData };
    $("#create-event-form").modal("toggle");
  };

  const duplicateEvent = (event) => {
    const { id, ...rest } = event;
    eventData.value = { ...rest };
    const selectedCategory = eventData.value.event_category_id;
    $("#create-event-form").modal("toggle");
  };

  const showEventModal = async (event) => {
    eventData.value = { 
      ...event, 
      top_banner_img_url: event.event_img_url, 
      zone_img_url: event.zone_img_url 
    };

    $("#create-event-form").modal("toggle");
  };

  const submitForm = async () => {
    if (totalTickets.value > selectedVenueCapacity.value) {
      toast.error(
        `Το σύνολο των εισιτηρίων (${totalTickets.value}) ξεπερνά τη χωρητικότητα του χώρου (${selectedVenueCapacity.value}).`
      );
      return;
    }

    if (!eventData.value.id) {
      eventData.value.zones = (eventData.value.zones || []).map(
        ({ id, ...zoneRest }) => ({ ...zoneRest })
      );
      eventData.value.special_category_discounts = (
        eventData.value.special_category_discounts || []
      ).map(({ id, ...special_categoryRest }) => ({ ...special_categoryRest }));
    }

    const response = await createUpdateEvent(eventData.value.id, eventData.value);

    if (response.data.success) {
      if (!eventData.value.id) {
        eventData.value.id = response.data.data.event?.id || response.data.id;
      }


      if (selectedFile.value) {
        await filesUpload(selectedFile.value, eventData);
        selectedFile.value = null;
      }

      if (selectedTopBannerFile.value) {
        const res = await filesUpload(selectedTopBannerFile.value, eventData, 'event_img');
        if (res.data.success) {
          eventData.value.top_banner_img = res.data.filename; 
          selectedTopBannerFile.value = null;
        }
      }

      if (selectedZoneFile.value) {
        const res = await filesUpload(selectedZoneFile.value, eventData, 'zone_img');
        if (res.data.success) {
          eventData.value.zone_img = res.data.filename;
          selectedZoneFile.value = null;
        }
      }

      toast.success(response.data.message);
      $("#create-event-form").modal("toggle");
      fetchData();
    } else {
      toast.error(response.data.message);
    }
  };


  const searchAction = () => {
    setTimeout(() => {
      router.push({
        path: "/events",
        query: { ...route.query, search: $("#main-search-input").val() },
      });
    }, 300);
  };

  const attachEventListeners = () => {
    $(document.body).on("keyup", "#main-search-input", searchAction).on("click", "#main-search-input", searchAction);
  };

  const removeEventListeners = () => {
    $(document.body).off("keyup", "#main-search-input", searchAction).off("click", "#main-search-input", searchAction);
  };


  onMounted(() => {
    if (!eventData.value.event_dates || eventData.value.event_dates.length === 0) addDate();
    if (!eventData.value.zones || eventData.value.zones.length === 0) addZone();
    attachEventListeners();
    fetchCategories();
    fetchSpecialCategories();
    fetchVenues();
    useHead({
      title: "Εκδηλώσεις - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισιτηρίου",
      meta: [
        { name: "description", content: "Εκδηλώσεις - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισιτηρίου" },
        { property: "og:title", content: "Εκδηλώσεις - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισιτηρίου" },
        { property: "og:description", content: "Εκδηλώσεις - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισιτηρίου" },
      ],
    });
  });

  onUnmounted(() => removeEventListeners());
</script>


<style scoped>

.nav-tabs {
  border: 0px;
}

.nav-tabs .nav-link {
  border-bottom: 1px solid lightgray;
  color: #1E2B57;
  text-transform: uppercase;
}

.nav-link.active {
  color: #1E2B57;
  font-weight: bold;
  text-transform: uppercase;
  box-shadow: 0px -6px 8px -2px #ccc;
  border: 0px;
}

.active {
  background-color: #1E2B57;
}

.logo {
  font-size: 48px;
  color: #1E2B57;
  margin-right: 10px;
}

.nav-buttons {
  margin-top: 20px;
}

.description{
  font-size: 16px;
}

.event-card {
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0.3, 0.3, 0, 0.1);
}

.event-actions {
  margin-top: 10px;
}

.btn-secondary {
  background-color: #ddd;
}

.position-absolute {
  position: absolute;
}

.eventInnerDesc {
  background-color: var(--body-color);
  height: 300px;
  max-height: 300px;
  overflow-y: auto;
  padding-bottom: 0 !important;
}

.card-date {
  border-radius: 30px;
  font-size: smaller;
}

.cat-text {
  border: 1px solid;
  border-radius: 30px;
  padding: 3px 10px;
  margin-right: 5px;
  line-height: 1.5;
  font-size: smaller;
}

.event-actions {
  position: absolute;
  bottom: -15px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  left: 0;
}

.btn-company {
  background-color: #1E2B57;
  border-radius: 5px;
  color: white;
  transition: 0.5s;
}

.btn-company:hover {
  background-color: #2a4877;
  color: white;
  transition: 0.5s;
}

.modal-content {
  border-radius: 40px;
}

.list-ordered{
  font-size: 14px;
}

.card-date{
  font-size: 15px;
}

.btn-close{
  right: 5px;
  top:5px;
}

.special-category-title,
.zones-title{
  font-size: 14px;
}

@media (max-width: 576px) {
  
  .justify-content-center-mobile {
    justify-content: center !important;
  }

  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: #fff;
    background-color: #1E2B57;
    border-color: #1E2B57;
  }

  .form-control,
  .form-select {
    background-color: #ffffff;
  }

  .form-label{
    font-size: 14px;
  }

  .nav-link{
    padding-left:0;
    padding-right:0;
  }
}

</style>